import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UiTranslateModule } from '@fcom/ui-translate';
import { IconButtonComponent } from '@fcom/ui-components/components/buttons/icon-button/icon-button.component';

import { DirectiveModule } from '../../directives/directive.module';
import { NavigationTriggerComponent } from './navigation/navigation-trigger/navigation-trigger.component';
import { ComponentsModule } from '../components.module';
import { PipesModule } from '../../pipes/pipes.module';
import { HeaderBoxesModule } from './header-boxes.module';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    PipesModule,
    DirectiveModule,
    UiTranslateModule,
    IconButtonComponent,
    HeaderBoxesModule,
  ],
  declarations: [NavigationTriggerComponent],
  exports: [NavigationTriggerComponent, HeaderBoxesModule],
})
export class NavigationTriggerModule {}
